// extracted by mini-css-extract-plugin
export default {"autocomplete":"afofW7","bottom":"bfofW7","top":"cfofW7","option":"dfofW7"};